export var DixaMessengerPanelForms;
(function (DixaMessengerPanelForms) {
    DixaMessengerPanelForms["LanguageCustomizationPageForm"] = "DixaMessengerCsatLanguageCustomizationPageForm";
    DixaMessengerPanelForms["GlobalSettingsForm"] = "DixaMessengerCsatGlobalSettingsForm";
})(DixaMessengerPanelForms || (DixaMessengerPanelForms = {}));
